export default "__VITE_ASSET__1ee49c35__"